import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Form, Input, Label } from "../../../styles";
import { useSupplierContext } from "../../../context/supplier_context";
import { emailPlaceholder, namePlaceholder, phonePlaceholder } from "../../../utils/data";
import Api from "../../../api/axios";
import { useUserContext } from "../../../context/user_context";


const EditSupplier = (props) => {


  const [issending, setissending] = useState(false);

  const [formField, setformField] = useState({ name: "", mail: "", phone: "" });

  const {
    showEditSupplier, CloseEditSupplier,
    getSupplierData
  } = useSupplierContext();

  const { btoken } = useUserContext();

  const { id: sid, name, phone, mail } = props;

  useEffect(() => {
    if (props) {
      setformField({
        name, mail, phone
      });
    }
  }, [props]);


  function handleChange(e) {
    setformField((inputs) => ({
      ...inputs,
      [e.target.name]: e.target.value,
    }));
  }


  function submitFn(e) {
    e.preventDefault();
    if (formField.name) {
      setissending(true);
      const data = {
        btoken,
        sid,
        name: formField.name,
        phone: formField.phone,
        mail: formField.mail,
      };

      Api.post(`/editSupplier`, data)
        .then((res) => {
          if (res.success === false) {
            toast.warn(res.message);
            setissending(false);
          } else {
            setissending(false);
            toast.success(res.message);
            getSupplierData();
            CloseEditSupplier();
          }
        })
        .catch((error) => {
          setissending(false);
        });
    } else {
      setissending(false);
      toast.error("Name is required !!!");
    }
  }

  return (
    <>
      <Modal
        show={showEditSupplier}
        onHide={CloseEditSupplier}
        backdrop="static"
        keyboard={true}
        centered
        size="lg"
      >
        <Modal.Body>
          <Modal.Header closeButton>
            <h6 className="fw-bold pry-text">
              Edit Supplier
            </h6>
          </Modal.Header>

          <div className="container">

            <Form onSubmit={(e) => submitFn(e)}>

              <Label> Name: <span>*</span> </Label>
              <Input
                type="text"
                name="name"
                placeholder={namePlaceholder}
                onChange={handleChange}
                required
                value={formField.name}
              />

              <Label> Phone Number:</Label>
              <Input
                type="number"
                name="phone"
                placeholder={phonePlaceholder}
                onChange={handleChange}
                value={formField.phone}
              />

              <Label> Email:</Label>
              <Input
                type="email"
                name="mail"
                placeholder={emailPlaceholder}
                onChange={handleChange}
                value={formField.mail}
              />

              <div className="col-md-10 mx-auto text-center mb-4">

                <Button
                  pry
                  type="submit"
                  disabled={issending}
                  className="btn m-0 w-100"  >
                  {issending ? 'loading...' : "Submit"}
                </Button>
              </div>
            </Form>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

export default EditSupplier;
